const linkLandingPagesPT = {
    "view": {
        "table": {
            "title": "Suas páginas de destino de links",
            "column": {
                "title": "Título",
                "description": "Descrição",
                "backUrl": "URL de Retorno",
                "created": "Criado",
                "landingPage": "Página de Destino",
                "action": "Ação"
            },
            "label": {
                "landingPage": "Página de Destino"
            },
            "button": {
                "view": "Visualizar",
                "export_csv": "Exportar CSV"
            },
            "placeholder": {
                "search": "Pesquisar..."
            },
            "message": {
                "linkCopied": "Link copiado para a área de transferência!"
            }
        },
        "modal": {
            "edit": {
                "header": "Editar {{linkLandingPageName}}?",
                "body": "Tem certeza de que deseja editar esta página de destino de link?"
            },
            "delete": {
                "header": "Excluir {{linkLandingPageName}}?",
                "body": "Tem certeza de que deseja excluir esta página de destino de link?"
            }
        },
        "message": {
            "success": "Página de Destino de Link foi removida!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!",
            "llpAllowanceSpent": "Você gastou sua cota de páginas de destino de links. Para criar mais páginas de destino de links, por favor, atualize sua conta ou entre em contato com nossa equipe de suporte.",
            "subscriptionFeatureUnavailable": "Seu plano de assinatura atual não suporta este recurso. Por favor, <1>atualize</1> seu plano de assinatura para utilizar este recurso.",
            "subscriptionExpired": "Sua assinatura expirou. Por favor, <1>retome</1> sua assinatura para utilizar este recurso.",
            "noAccess": "Você não tem acesso a este módulo, por favor, entre em contato com a equipe de suporte para mais informações."
        }
    },
    "add": {
        "title": "Adicionar Página de Destino de Link",
        "form": {
            "label": {
                "domain": "Domínio",
                "title": "Título",
                "backUrl": "URL de Retorno",
                "shortDescription": "Descrição Curta",
                "logo": "Logo",
                "backgroundImage": "Imagem de Fundo",
                "blurredBackground": "Fundo Desfocado",
                "blurred": "Desfocado",
                "notBlurred": "Não Desfocado",
                "blurStrength": "Força do Desfoque",
                "layout": "Layout",
                "font": "Fonte",
                "socialIconPlacement": "Posicionamento do Ícone Social",
                "socialIconColor": "Cor do Ícone Social",
                "buttonCorners": "Cantoneiras do Botão",
                "buttonStyle": "Estilo do Botão",
                "colorCustomisation": "Personalização de Cor",
                "premadeColors": "Cores Prontas",
                "customColors": "Cores Personalizadas",
                "headerBackground": "Fundo do Cabeçalho",
                "singleColor": "Cor Única",
                "gradient": "Gradiente",
                "bodyBackground": "Fundo do Corpo",
                "titleColor": "Cor do Título",
                "descriptionColor": "Cor da Descrição",
                "buttonColor": "Cor do Botão",
                "buttonTextColor": "Cor do Texto do Botão",
                "backgroundColor": "Cor de Fundo"
            },
            "placeholder": {
                "domain": "Selecionar Domínio",
                "shortDescription": "Algumas palavras sobre sua página de destino. Máximo de 80 caracteres"
            },
            "help_text": {
                "domain": "Selecione o domínio para o qual você deseja criar a Página de Destino de Link.",
                "logo": "Carregar formatos JPG ou PNG, resolução de pelo menos 500x500 px",
                "backgroundImage": "Carregar formatos JPG ou PNG, resolução de 1000x1000 px"
            },
            "options": {
                "layout": {
                    "layoutOne": "Layout Um",
                    "layoutTwo": "Layout Dois"
                },
                "socialIconPlacement": {
                    "header": "Cabeçalho",
                    "bottomOfTheBody": "Parte Inferior do Corpo"
                },
                "socialIconColor": {
                    "color": "Cor",
                    "black": "Preto",
                    "white": "Branco"
                },
                "buttonCorners": {
                    "rounded": "Arredondado",
                    "semiRounded": "Semi Arredondado",
                    "squared": "Quadrado"
                },
                "buttonStyle": {
                    "outlined": "Contornado",
                    "filled": "Preenchido"
                }
            },
            "button": {
                "submit": "Enviar"
            },
            "validation": {
                "formInvalid": "O formulário não pode ser enviado! Por favor, preencha todos os campos e verifique os erros!",
                "storeUrlRequired": "URL de {{store}} é necessário",
                "storeUrlValid": "Por favor, adicione um URL válido de {{store}}."
            }
        },
        "message": {
            "success": "Página de Destino de Link foi adicionada!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
        },
        "modal": {
            "add": {
                "header": "Adicionar Página de Destino {{title}}?",
                "body": "Tem certeza de que deseja criar a Página de Destino de Link com o título {{title}}?"
            }
        }
    },
    "update": {
        "title": "Atualizar Página de Destino de Link",
        "form": {
            "label": {
                "domain": "Domínio",
                "title": "Título",
                "backUrl": "URL de Retorno",
                "shortDescription": "Descrição Curta",
                "logo": "Logo",
                "backgroundImage": "Imagem de Fundo",
                "blurredBackground": "Fundo Desfocado",
                "blurred": "Desfocado",
                "notBlurred": "Não Desfocado",
                "blurStrength": "Força do Desfoque",
                "layout": "Layout",
                "font": "Fonte",
                "socialIconPlacement": "Posicionamento do Ícone Social",
                "socialIconColor": "Cor do Ícone Social",
                "buttonCorners": "Cantoneiras do Botão",
                "buttonStyle": "Estilo do Botão",
                "colorCustomisation": "Personalização de Cor",
                "premadeColors": "Cores Prontas",
                "customColors": "Cores Personalizadas",
                "headerBackground": "Fundo do Cabeçalho",
                "singleColor": "Cor Única",
                "gradient": "Gradiente",
                "bodyBackground": "Fundo do Corpo",
                "titleColor": "Cor do Título",
                "descriptionColor": "Cor da Descrição",
                "buttonColor": "Cor do Botão",
                "buttonTextColor": "Cor do Texto do Botão",
                "backgroundColor": "Cor de Fundo"
            },
            "placeholder": {
                "domain": "Selecionar Domínio",
                "shortDescription": "Algumas palavras sobre sua página de destino. Máximo de 80 caracteres"
            },
            "help_text": {
                "domain": "Selecione o domínio para o qual você deseja criar a Página de Destino de Link.",
                "logo": "Carregar formatos JPG ou PNG, resolução de pelo menos 500x500 px",
                "backgroundImage": "Carregar formatos JPG ou PNG, resolução de 1000x1000 px"
            },
            "options": {
                "layout": {
                    "layoutOne": "Layout Um",
                    "layoutTwo": "Layout Dois"
                },
                "socialIconPlacement": {
                    "header": "Cabeçalho",
                    "bottomOfTheBody": "Parte Inferior do Corpo"
                },
                "socialIconColor": {
                    "color": "Cor",
                    "black": "Preto",
                    "white": "Branco"
                },
                "buttonCorners": {
                    "rounded": "Arredondado",
                    "semiRounded": "Semi Arredondado",
                    "squared": "Quadrado"
                },
                "buttonStyle": {
                    "outlined": "Contornado",
                    "filled": "Preenchido"
                },
                "platform": {
                    "instagram": "Instagram",
                    "facebook": "Facebook",
                    "twitter": "Twitter",
                    "linkedin": "LinkedIn",
                    "tiktok": "TikTok",
                    "youtube": "YouTube",
                    "other": "Outro"
                }
            },
            "button": {
                "submit": "Enviar"
            }
        },
        "message": {
            "success": "Página de Destino de Link foi atualizada!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
        },
        "modal": {
            "update": {
                "header": "Atualizar Página de Destino {{title}}?",
                "body": "Tem certeza de que deseja atualizar a Página de Destino de Link com o título {{title}}?"
            }
        }
    },
    "socialLinksRow": {
        "title": "Links Sociais",
        "label": {
            "order": "Ordem",
            "platform": "Plataforma",
            "destinationUrl": "URL de Destino"
        },
        "options": {
            "platform": {
                "instagram": "Instagram",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "linkedin": "LinkedIn",
                "tiktok": "TikTok",
                "youtube": "YouTube",
                "other": "Outro"
            }
        },
        "button": {
            "remove": "Remover",
            "add": "Adicionar Outro"
        }
    },
    "featuredLinksRow": {
        "title": "Links em Destaque",
        "label": {
            "order": "Ordem",
            "label": "Rótulo",
            "destinationUrl": "URL de Destino"
        },
        "button": {
            "remove": "Remover",
            "add": "Adicionar Outro"
        }
    },
    "viewAnalytics": {
        "label": {
            "fetchingAnalytics": "Buscando Análises para Link de Música"
        },
        "button": {
            "last7Days": "Últimos 7 Dias",
            "last14Days": "Últimos 14 Dias",
            "last30Days": "Últimos 30 Dias"
        },
        "linkLandingPageViews": {
            "title": "Visualizações da Página de Destino de Link",
            "subtitle": "Total de Visualizações",
            "label": {
                "views": "Visualizações"
            }
        },
        "socialLinkClicks": {
            "title": "Cliques em Links Sociais",
            "subtitle": "Total de Cliques",
            "table": {
                "column": {
                    "platform": "Plataforma",
                    "destinationUrl": "URL de Destino",
                    "clicks": "Cliques",
                    "clicksPct": "Cliques (%)"
                }
            }
        },
        "featuredLinkClicks": {
            "title": "Cliques em Links em Destaque",
            "subtitle": "Total de Cliques",
            "table": {
                "column": {
                    "label": "Rótulo",
                    "destinationUrl": "URL de Destino",
                    "clicks": "Cliques",
                    "clicksPct": "Cliques (%)"
                }
            }
        },
        "topTerritories": {
            "title": "Principais Territórios",
            "subtitle": "Total de Visualizações",
            "table": {
                "column": {
                    "territory": "Território",
                    "views": "Visualizações",
                    "viewsPct": "Visualizações (%)"
                },
                "label": {
                    "otherTerritories": "Outros Territórios"
                }
            }
        },
        "topBrowsers": {
            "title": "Principais Navegadores",
            "subtitle": "Total de Visualizações",
            "table": {
                "column": {
                    "browser": "Navegador",
                    "views": "Visualizações",
                    "viewsPct": "Visualizações (%)"
                }
            }
        },
        "topDeviceTypes": {
            "title": "Principais Tipos de Dispositivos",
            "table": {
                "column": {}
            }
        },
        "topOperatingSystems": {
            "title": "Principais Sistemas Operacionais",
            "label": {
                "os": "Sistema Operacional",
                "views": "Visualizações"
            }
        }
    }
};

export default linkLandingPagesPT;